import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmModalComponent } from './pages/escrituras/solicitacao-form/confirm-modal/confirm-modal.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/escrituras/solicitacao-form/solicitacao-form.module').then(m => m.SolicitacaoFormModule) },
  { path: 'consulta', loadChildren: () => import('./pages/escrituras/consulta/consulta.module').then(m => m.ConsultaModule) },
  { path: 'finish/:id', loadChildren: () => import('./pages/escrituras/finish/finish.module').then(m => m.FinishModule) },
  { path: 'confirm', component: ConfirmModalComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
